import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import {
  SurveySelector,
  type SurveySelectorProps,
} from '~/components/features/SurveySelector'
import {
  type Survey,
  useBrandAccountQueryBrandAccount,
} from '~/hooks/useBrandAccountQuery'
import { useFormField } from '~/hooks/useFormField'
import { useLogEvent } from '~/hooks/useLogEvent'

import { type InputValues } from '../utils'

export const SurveyInput = () => {
  const { control, setValue } = useFormContext<InputValues>()
  const surveyIdField = useFormField(control, 'surveyId')
  const { t } = useTranslation()

  const brandAccount = useBrandAccountQueryBrandAccount()
  const surveys = React.useMemo(
    () => brandAccount.surveys,
    [brandAccount.surveys],
  )

  const logEvent = useLogEvent()
  const handleChange = React.useCallback<
    EH<SurveySelectorProps<Survey>, 'onChange'>
  >(
    (surveyId) => {
      surveyIdField.onChange(surveyId)
      setValue('brandGroupId', null)
      setValue('brandId', null)
      logEvent('Select survey', { withSuffix: true })
    },
    [logEvent, setValue, surveyIdField],
  )

  return (
    <LabelingContainer label={t('survey_1')}>
      <SurveySelector
        surveys={surveys}
        width={160}
        {...surveyIdField}
        onChange={handleChange}
      />
    </LabelingContainer>
  )
}
